import React, { useEffect, useState } from 'react';

import { Link, useNavigate } from 'react-router-dom';
import Header from 'thesis-and-dissertations/layouts/app/components/Header';
import Footer from 'thesis-and-dissertations/layouts/app/components/Footer';
import InputSearch from 'thesis-and-dissertations/layouts/app/components/InputSearch';
import { useSearchParams } from 'react-router-dom'
import './style.css'
import Api from '../../helpers/api';
import { hasResearchType } from '../../helpers/helper'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError';
const api = new Api();

const ContentSearch = (props) => {
    const navigate = useNavigate();
    let [searchParams] = useSearchParams();
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [thesis, setThesis] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedLanguage, setSelectedLanguage] = useState([]);
    const [selectedCountries, setSelectedCountries] = useState([]);
    const [selectedPublishedYear, setSelectedPublishedYear] = useState([]);
    const [pagination, setPagination] = useState({ per_page: 10 });
    const [searchCategories, setSearchCategories] = useState();
    const [searchThesis, setSearchThesis] = useState({});
    const [valueInputSearch, setValueInputSearch] = useState('');
    const [listPublishDate, setListPublishDate] = useState([])
    const [countries, setCountries] = useState([])
    const [loading, setLoading] = useState({})
    const [totalThesis, setTotalThesis] = useState(0)

    useEffect(() => {
        // COMMENTED: Research type check - not needed without login system
        // if (!hasResearchType()) {
        //     navigate('/research-type')
        //     return
        // }

        fetchLanguages();
        fetchPublishDate()
        fetchCountries()
        fetchTotalThesis()

        if (searchParams.get('q')) {
            fetchThesis({ JudulTugasAkhir: searchParams.get('q') })
            setValueInputSearch(searchParams.get('q'))
        }

        if (searchParams.get('category')) {
            fetchThesis({
                BidangKeilmuanId: parseInt(searchParams.get('category'))
            })

            setSelectedCategories([...selectedCategories, {
                id_bidang_keilmuan: parseInt(searchParams.get('category')),
                bidang_keilmuan: searchParams.get('categoryName')
            }])
        }
    }, []);

    useEffect(() => {
        // if (searchParams.get('q') || searchParams.get('category')) {
        //     return
        // }

        fetchThesis({ ...searchThesis })
    }, [searchThesis]);

    useEffect(() => {
        fetchCategories(searchCategories);
    }, [searchCategories]);

    useEffect(() => {
        setSearchThesis({
            ...searchThesis,
            JudulTugasAkhir: valueInputSearch,
            BidangKeilmuanId: selectedCategories.map(item => item.id_bidang_keilmuan),
            BahasaId: selectedLanguage.map(item => item.Id),
            TahunPublish: selectedPublishedYear,
            country: selectedCountries.map(item => item),
        });
    }, [
        valueInputSearch,
        selectedCategories,
        selectedLanguage,
        selectedCountries,
        selectedPublishedYear
    ]);

    const fetchTotalThesis = () => {
        api.getTotalThesis()
            .then(response => {
                const { data } = response
                setTotalThesis(data?.total)
            }).catch((error) => {
                const { data, status } = error.response
                setErrors(data?.meta?.error)
                handleApiError(error)
            })
    };

    const fetchCountries = (params = {}) => {
        setLoading({ ...loading, country: true })
        api.getCountry({ ...params })
            .then(response => {
                const data = response.data.data;
                setCountries(data)
                setLoading({ ...loading, country: false })
            }).catch((error) => {
                const { data, status } = error.response
                setErrors(data?.meta?.error)
                setLoading({ ...loading, country: false })
                handleApiError(error)
            })
    };

    const fetchPublishDate = (params = {}) => {
        setLoading({ ...loading, publishDate: true })
        api.getPublishDate({ ...params })
            .then(response => {
                const data = response.data.data;
                setListPublishDate(data)
                setLoading({ ...loading, publishDate: false })
            }).catch((error) => {
                const { data, status } = error.response
                setErrors(data?.meta?.error)
                setLoading({ ...loading, publishDate: false })
                handleApiError(error)
            })
    };

    const fetchCategories = (params = {}) => {
        setIsLoading(true);
        api.getScientificField({ ...params })
            .then(response => {
                setIsLoading(false);
                const data = response.data;
                setCategories(data);
            }).catch((error) => {
                const { data } = error.response;
                setErrors(data?.meta?.error);
                setIsLoading(false);
                handleApiError(error)
            });
    };

    const fetchLanguages = (params = {}) => {
        setIsLoading(true);
        api.getLanguage({ ...params })
            .then(response => {
                setIsLoading(false);
                const data = response.data;
                setLanguages(data);
            }).catch((error) => {
                const { data } = error.response;
                setErrors(data?.meta?.error);
                setIsLoading(false);
                handleApiError(error)
            });
    };

    const fetchThesis = (params = {}) => {
        setIsLoading(true);
        api.getThesis({ ...params })
            .then(response => {
                setIsLoading(false);
                const data = response.data;

                let pagination = {};
                pagination.from = data.data.from;
                pagination.current = data.data.current_page;
                pagination.lastPage = data.data.last_page;
                pagination.prevPageUrl = data.data.prev_page_url;
                pagination.lastPageUrl = data.data.last_page_url;
                pagination.perPage = data.data.per_page;
                pagination.total = data.data.total;
                pagination.pageSize = parseInt(data.data.per_page);

                setThesis(data.data.data);
                setPagination(pagination);
            }).catch((error) => {
                const { data } = error.response;
                setErrors(data?.meta?.error);
                setIsLoading(false);
                handleApiError(error)
            });
    };

    const handleChangeCategories = (isChecked, data) => {
        isChecked
            ? setSelectedCategories([...selectedCategories, data])
            : setSelectedCategories(selectedCategories.filter(item => item.id_bidang_keilmuan !== data.id_bidang_keilmuan));
    };

    const handleChangeLanguage = (isChecked, data) => {
        isChecked
            ? setSelectedLanguage([...selectedLanguage, data])
            : setSelectedLanguage(selectedLanguage.filter(item => item.Id !== data.Id));
    };

    const handleChangeCountries = (isChecked, selectedCountry) => {
        isChecked
            ? setSelectedCountries([...selectedCountries, selectedCountry])
            : setSelectedCountries(selectedCountries.filter(country => country !== selectedCountry));
    };

    const handleChangePublishedYear = (isChecked, selectedYear) => {
        isChecked
            ? setSelectedPublishedYear([...selectedPublishedYear, selectedYear])
            : setSelectedPublishedYear(selectedPublishedYear.filter(year => year !== selectedYear));
    };

    const handleChangePage = (page) => {
        const pager = { ...pagination };
        pager.current = page;

        // setPagination(pager);

        fetchThesis({
            per_page: pager.perPage,
            page: page,
            ...searchThesis,
        });
    };

    const handleSearchCategories = (e) => {
        if (e.keyCode !== 13) {
            return;
        }
        setSearchCategories({ ...{ q: e.target.value } });
    };

    const handleSearchThesis = (text) => {
        setSearchThesis({
            ...searchThesis,
            JudulTugasAkhir: text
        });
    };

    const handleChangeValueInputSearch = (text) => {
        setValueInputSearch(text);
    };

    const handleChangePerPage = (e) => {
        let perPage = e.target.value
        const pager = { ...pagination };
        pager.per_page = perPage;

        setPagination(pager);

        fetchThesis({
            ...searchThesis,
            per_page: perPage,
        });
    }

    return (
        <div className='container-fluid p-0 overflow-hidden' style={{ backgroundColor: '#FAF9F5' }}>
            <Header button={true} />

            <div style={styles.bgImage} className='p-10 search-box'>
                <div className='p-15 search-box-content'>
                    <div className='text-center'>
                        <p className='display-6 fw-bold mb-5 text-white fw-bold title-thesis'>Tesis & Disertasi</p>
                        <p className='fs-6 fw-bold mb-15 text-white'>Berisi {totalThesis?.toLocaleString()} Karya Akhir Alumni LPDP</p>
                    </div>

                    <div className='d-flex justify-content-center mb-15'>
                        <InputSearch
                            categories={categories}
                            onSearchThesis={handleSearchThesis}
                            valueInputSearch={valueInputSearch}
                            handleChangeValueInputSearch={handleChangeValueInputSearch} />
                    </div>
                </div>
            </div>

            <div className='row px-15'>
                <div className='row'>
                    <div className='col-md-9'>

                        <div className='mt-6'>
                            {selectedCategories?.map((item, key) => {
                                return (
                                    <span
                                        key={key}
                                        className='badge badge-dark p-3 m-2 rounded-pill'>
                                        {item.bidang_keilmuan}
                                        <span
                                            onClick={() => handleChangeCategories(false, item)}
                                            className='mx-3'
                                            style={{ cursor: 'pointer' }}>&times;</span>
                                    </span>
                                )
                            })}
                        </div>

                        <p className='float-end'>Result per page</p> <br />

                        <div className='float-end mt-2'>
                            <select
                                value={pagination.perPage}
                                className="p-2"
                                onChange={handleChangePerPage}>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>

                        <div className='row px-5'>
                            <button className='btn btn-sm col-lg-3 col-md-12 col-sm-12 col-xs-12 text-center pt-15'
                                disabled={pagination.current == pagination.from}
                                onClick={() => handleChangePage(pagination.current - 1)}>
                                <i>« Prev</i>
                            </button>

                            <div className='col-lg-3 col-md-12 col-sm-12 col-xs-12 text-center pt-15'>
                                <p className='fw-bold'>Halaman {pagination.current} of {pagination.lastPage}</p>
                            </div>

                            <button className='btn btn-sm col-lg-3 col-md-12 col-sm-12 col-xs-12 text-center pt-15'
                                disabled={pagination.current == pagination.lastPage}
                                onClick={() => handleChangePage(pagination.current + 1)}>
                                <i>» Next</i>
                            </button>
                        </div>

                        <div style={{
                            height: '800px',
                            overflow: 'scroll',
                        }}
                            className='mt-10'>
                            {isLoading ? 'Loading...' : thesis?.map((item, key) => {
                                return (
                                    <div className='pb-10' key={key}>
                                        <Link to={`/content/${item?.Id}`}>
                                            <div className='card p-10'>
                                                <div className='row'>
                                                    <div className='col-md-8'>
                                                        <p className='fw-bold mb-6 fs-6 text-black'>{item?.JudulTugasAkhir}</p>

                                                        <span className='mb-6' style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                            <p className='text-black'>Published by</p>
                                                            <b className='fw-bold mx-2 text-black'>{item?.Author}</b>
                                                        </span>

                                                        <p className='fw-bold text-black'>Kata Kunci</p>
                                                        <p className='text-black'>
                                                            {item?.katakunci?.map((data, index) => (
                                                                <span key={index}>{data?.KataKunci}, </span>
                                                            ))}
                                                        </p>
                                                    </div>
                                                    <div className='col-md-4 text-black'>
                                                        <p className='mb-8 text-black'>{item?.TahunPublish}</p>
                                                        <p className='text-black'>Key:</p>
                                                        <p className='text-black'>{item?.KodeRegistrasi}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                )
                            })}
                        </div>
                    </div>

                    <div className='col-md-3'>
                        <div className='row px-5 pt-10 justify-content-center ml-5'>
                            <div className='ml-5'>
                                <p className='fw-bold mb-2'>BIDANG KEILMUAN</p>
                                <input type='text'
                                    placeholder='Ketik lalu enter untuk mencari'
                                    className='p-2 w-100'
                                    onKeyDown={(e) => handleSearchCategories(e)} />
                            </div>

                            <div>
                                {categories?.map((item, key) => {
                                    return (
                                        <div key={key} className={key == 0 ? 'mt-8' : 'mt-2'} style={{ alignItems: 'center' }}>
                                            <input type='checkbox'
                                                value={item.id_bidang_keilmuan}
                                                checked={selectedCategories.find((category) => { return category.id_bidang_keilmuan === item.id_bidang_keilmuan }) ? true : false}
                                                onChange={(e) => handleChangeCategories(e.target.checked, item)}
                                            />
                                            <label className='px-1'>{item.bidang_keilmuan}</label>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>

                        <div className='row px-5 pt-5 justify-content-center ml-5'>
                            <div className='mt-5'>
                                <p className='fw-bold mb-2'>BAHASA</p>
                            </div>

                            <div style={{
                                // height: '200px',
                                height: languages?.length > 10 ? '200px' : 'auto',
                                overflow: 'scroll'
                            }}>
                                {languages?.map((item, key) => {
                                    return (
                                        <div className='mt-2' key={key} style={{ alignItems: 'center' }}>
                                            <input type='checkbox'
                                                value={item.Id}
                                                onChange={(e) => handleChangeLanguage(e.target.checked, item)} />
                                            <label className='px-2'>{item.Bahasa}</label>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>

                        <div className='row px-5 pt-5 justify-content-center ml-5'>
                            <div className='mt-5'>
                                <p className='fw-bold mb-2'>PUBLISHERS' COUNTRIES</p>
                            </div>

                            <div style={{
                                height: countries?.length > 10 ? '200px' : 'auto',
                                overflow: 'scroll'
                            }}>
                                {countries?.map((item, key) => {
                                    return (
                                        <div className='mt-2' key={key} style={{ alignItems: 'center' }}>
                                            <input type='checkbox'
                                                value={item}
                                                onChange={(e) => handleChangeCountries(e.target.checked, item)} />
                                            <label className='px-2'>{item}</label>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>

                        <div className='row px-5 pt-5 justify-content-center ml-5 mb-10'>
                            <div className='mt-5'>
                                <p className='fw-bold mb-2'>DATE ADDED</p>
                            </div>

                            <div style={{
                                height: listPublishDate?.length > 10 ? '200px' : 'auto',
                                overflow: 'scroll'
                            }}>
                                {listPublishDate?.map((item, key) => {
                                    return (
                                        <div className='mt-2' key={key} style={{ alignItems: 'center' }}>
                                            <input type='checkbox'
                                                value={item}
                                                onChange={(e) => handleChangePublishedYear(e.target.checked, item)} />
                                            <label className='px-2'>{item}</label>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div >
    );
};

const styles = {
    bgImage: {
        backgroundColor: '#F95E2F',
    },
    badge: {
        border: '1px solid #F95E2F'
    },
}

export default ContentSearch;